module.exports = __webpack_public_path__ + "static/invoices-b878eb260aea67155960af7e31384a46.svg";